<div class="ac-products-form-checkbox">
  <mat-checkbox [attr.data-test]="property.Key" color="primary" [formControl]="propertyForm"
    ><span>{{ propertyType.NameId ? (propertyType.NameId | translate) : property.Key }}</span>
    <span
      *ngIf="propertyType | tooltipTextId"
      class="ac-label-tooltip-container"
      [matTooltip]="propertyType | tooltipTextId | translate"
      [matTooltipPosition]="'above'"
      ><mat-icon class="ac-tooltip-icon help" svgIcon="help_outline"></mat-icon
    ></span>
  </mat-checkbox>
  <!-- There cannot be validations on checkbox fields, but still there could be Message entities, which are related to the property (like info, when checkbox unchecked) -->
  <div *ngFor="let message of messages">
    <div
      [ngClass]="{
        'ac-form-field-message-error': message.Properties['Level']?.Value === 0,
        'ac-form-field-message-warning': message.Properties['Level']?.Value === 1,
        'ac-form-field-message-info': message.Properties['Level']?.Value === 2
      }"
    >
      {{ message.Properties['Text']?.Value || (message.Properties['TextId']?.Value | translate) }}
    </div>
  </div>
</div>
